import { useEffect } from 'react';

const CLASS_NAME = 'print-invoice-only';

/**
 * While mounted, marks the document so @media print CSS hides global chrome
 * (nav, footer) and only the invoice main content prints cleanly.
 *
 * Sets a short `document.title` so the browser’s print/PDF footer (when
 * “Headers and footers” is on) does not show the long marketing title from
 * index.html. URL and date in that footer can only be removed by turning off
 * headers/footers in the print dialog (see InvoicePrintBrowserHint).
 */
export function useInvoicePrintLayout(documentTitleForPrint = 'Sąskaita') {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = documentTitleForPrint;
    document.documentElement.classList.add(CLASS_NAME);
    return () => {
      document.documentElement.classList.remove(CLASS_NAME);
      document.title = previousTitle;
    };
  }, [documentTitleForPrint]);
}
